import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    console.error('Bootstrap error:', err);
    console.error('Error message:', err.message);
    console.error('Error code:', err.code);
    console.error('Error name:', err.name);
    console.error('All error properties:', Object.keys(err));
    console.error('Error toString:', err.toString());
    // Try to access Angular-specific error properties
    if (err.ngDebugContext) console.error('ngDebugContext:', err.ngDebugContext);
    if (err.ngErrorCode) console.error('ngErrorCode:', err.ngErrorCode);
    if (err.error) console.error('Nested error:', err.error);
  });
